import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const InventoryConfigurationSkeleton = () => {
  return (
    <Styles.SectionContainer>
      <Skeleton variant="text" width={280} height={28} />
      <Skeleton variant="text" width="100%" height={20} />
      <Styles.FieldsGrid>
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.FieldsGrid>
    </Styles.SectionContainer>
  )
}

export default InventoryConfigurationSkeleton
